__turbopack_context__.v({
  "className": "great_vibes_7819ca1a-module__Ba-fjW__className",
});
